export default {
      id: "ar_galerie-usage",
      viewBox: "0 0 40 40",
      url: "../dist/images/" + "sprite.svg#ar_galerie-usage",
      toString: function () {
        return this.url;
      }
    }